// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__1j07W","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__veZrL"};